import React from "react";
import GlobalCard from "../../../components/GlobalCardComponent";
import { Box, Divider, Grid, LinearProgress, Typography } from "@mui/material";
import Loader from "../../../../SAPPages/components/Loader/Loader";

export default function ProgressCard({ attendanceDetails, loading }) {
  const total_sessions = attendanceDetails?.total_sessions;
  const remaining_sessions = attendanceDetails?.remaining_sessions;
  const completedSession = total_sessions - remaining_sessions;

  const completedPercentage = (completedSession / total_sessions) * 100;
  return (
    <GlobalCard height="100%" padding="10px">
      <Grid container spacing={2} px={1}>
        <Grid item xs={12} container gap={1} alignItems="center">
          <Box width={44}>
            <img src="/newdashboard/Classrom/Attendance/Group 1000016696.png" />
          </Box>
          <Typography
            color="#000000"
            fontFamily="Inter"
            fontSize="18px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            style={{ fontWeight: 400 }}
          >
            My Progress
          </Typography>
        </Grid>

        <Grid item xs={12}>
          {" "}
          <Box height="1px" sx={{ background: "#dddddd" }} width="100%"></Box>
        </Grid>

        {loading ? (
          <Grid item xs={12}>
            <Loader height="40vh" text="Loading Progress Details..." />
          </Grid>
        ) : (
          <>
            <Grid item xs={12}>
              <Box display="flex" justifyContent="space-between">
                <Typography
                  color="#444444"
                  fontFamily="Inter"
                  fontSize="14px"
                  lineHeight="100%"
                  letterSpacing="0px"
                  fontStyle="normal"
                  style={{ fontWeight: 400 }}
                >
                  Session Completed
                </Typography>

                <Typography
                  color="#9D0385"
                  fontFamily="Inter"
                  fontSize="14px"
                  lineHeight="100%"
                  letterSpacing="0px"
                  fontStyle="normal"
                  style={{ fontWeight: 400 }}
                >
                  {completedSession}{" "}
                  <span style={{ color: "#444444" }}>
                    / {attendanceDetails?.total_sessions}
                  </span>
                </Typography>
              </Box>
              <Box mt={1.3} sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ width: "100%", mr: 1 }}>
                  <LinearProgress
                    variant="determinate"
                    value={completedPercentage}
                    sx={{
                      "& .MuiLinearProgress-bar": {
                        backgroundColor: "#BD11A2", // your custom color
                      },
                      backgroundColor: "#f8d9ee", // optional: track color
                      height: "10px",
                      borderRadius: "5px",
                    }}
                  />
                </Box>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              container
              justifyContent="center"
              alignItems="center"
              mt={2}
            >
              {" "}
              <Box width={36}>
                <img src="/newdashboard/Classrom/Attendance/Group 1000016696 (3).png" />
              </Box>
            </Grid>

            <Grid item xs={12} textAlign="center">
              <Typography
                color="#000000"
                fontFamily="Inter"
                fontSize="14px"
                lineHeight="100%"
                letterSpacing="0px"
                fontStyle="normal"
                style={{ fontWeight: 700 }}
              >
                Successful
              </Typography>

              <Grid item xs={12} textAlign="center">
                <Typography
                  mt={1}
                  color="#000000"
                  fontFamily="Inter"
                  fontSize="14px"
                  lineHeight="100%"
                  letterSpacing="0px"
                  fontStyle="normal"
                  style={{ fontWeight: 400 }}
                >
                  {completedSession} Sessions Completed
                </Typography>
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    </GlobalCard>
  );
}
